import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import {
  getParbankbranchBycriteria,
  GetParbankbranchBycriteriaParams,
  Parbankbranch,
} from 'services/parametersService';

export type BankBranchListSelectProps = SelectProps<any> & {
  paramsprop?: any;
  value?: any;
  onSelected?: (bank?: Parbankbranch) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  defaultValue?: any;
};

const BankBranchListSelect = ({
  paramsprop,
  value,
  onChange = noop,
  onSelected,
  allowClear,
  defaultValue,
  ...otherProps
}: BankBranchListSelectProps) => {
  const params: GetParbankbranchBycriteriaParams = {
    bkbranchaddress: paramsprop?.bkbranchaddress ?? '',
    bkbranchcode: paramsprop?.bkbranchcode ?? '',
    bkbranchname: paramsprop?.bkbranchname ?? '',
    bkcode: paramsprop?.bkcode ?? '',
  };

  const { data: BankBranchList, isLoading } = useQuery(
    ['getParbankbranchBycriteria', params],
    () => getParbankbranchBycriteria(params).then((res) => res.list || []),
    { enabled: params.bkcode !== '' }
  );

  const handleChange: SelectProps<number>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected)
      onSelected(
        BankBranchList?.find((bank) => bank.bkbranchcode === String(value))
      );
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      showSearch
      {...otherProps}
      loading={isLoading}
      defaultValue={defaultValue?.priid ?? defaultValue}
      allowClear={allowClear}
    >
      {BankBranchList?.map((bank) => (
        <Select.Option value={bank.bkbranchcode} key={bank.bkbranchcode}>
          {bank.bkbranchname + ' (' + bank.bkbranchcode?.slice(0,3) + ')'}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BankBranchListSelect;
